import skills from "../../data/MySkills.json";

export const requestGetSkills = async () => {
  return skills;
};
